export default __webpack_public_path__ + "static/media/SubLocation.3aac388a.svg";